import {
    AfterViewInit,
    Component,
    EventEmitter,
    Inject,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewEncapsulation
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import clone from 'just-clone';
import moment from 'moment';
import { combineLatest, ReplaySubject } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import * as XLSX from 'xlsx';
import * as fromLookups from '../../lookups';
import {
    DisplayMessageMinimum,
    Process,
    ResponseStatus
} from '../../shared';
import { MenuItem, TreeNode } from '../../shared/efaact-primeng.module';
import { IShowErrors } from '../../shared/errors-sidenav';
import { UnsavedChangesService } from '../../shared/modal-dialog';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { IContractStructure } from '../IContractStructure';
import { ICustomer } from '../ICustomer';
import { IEntityFilter } from '../IEntityFilter';
@Component({
    selector: 'ef-contract-structure-presenters',
    templateUrl: './contract-structure-presenters.component.html',
    styleUrls: ['./contract-structure-presenters.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ContractStructurePresentersComponent
    implements OnInit, AfterViewInit, OnDestroy
{
    @Input() public set errors(value: Array<string>) {
        this.log.debug({
            type: 'ContractStructurePresenterComponent:errors:set',
            value
        });
        this._errors = value;
        if (value && value.length) {
            this.errorHelpText = value
                .reduce((a, c) => a + c + '\r\n', '')
                .trim();
        } else {
            this.errorHelpText = '';
        }
        // handled by angular binding
    }
    public get errors(): Array<string> {
        return this._errors;
    }
    @Input() public set selectedError(value: IShowErrors) {
        this.log.debug({
            type: 'ContractStructurePresenterComponent:selectedError:set',
            value
        });
        try {
            if (value.MsgProcessID === this.process.ProcessID) {
                this._selectedError = value;
                if (value?.MsgEntityID) {
                    this.expandAncestorsFor(String(value.MsgEntityID));
                }
            }
        } catch (e) {
            this.log.error(e);
        }
    }
    public get selectedError(): IShowErrors {
        return this._selectedError;
    }
    @Input() public set jobs(value: Array<IContractStructure>) {
        if (!value || value.length === 0) {
            value = null;
        }
        if (value == null) {
            this._jobs = clone([]);
            // this.loadingData = false;
        } else {
            this._jobs = clone(value);
            this.JobsSubject.next(this.jobs);
        }
        // if (this.rowToToggle != null) {
        //     this.rowToToggle.treeExpand();
        // }
    }
    public get jobs(): Array<IContractStructure> {
        return this._jobs;
    }
    @Input('jobListStatus') set jobListStatus(value: Array<IEntityFilter>) {
        if (!value) {
            return;
        }

        this._jobliststatus = value.map(x => ({ ...x }));
        if (this.IsContractSelected == false) {
            this._jobliststatus.splice(1, 1);
        }
    }
    get jobListStatus(): Array<IEntityFilter> {
        return this._jobliststatus;
    }
    @Input('customers') set customers(value: Array<ICustomer>) {
        if (!value) {
            return;
        }

        this._customers = value.map(x => ({ ...x }));
        this.filteredCustomers = this._customers.filter(
            y => y.IsActive === true
        );
    }
    get customers(): Array<ICustomer> {
        return this._customers;
    }
    @Input() public set contractTypes(value: Array<fromLookups.IContractType>) {
        if (!value) {
            return;
        }

        this._contractTypes = value;
        this.ContractTypesSubject.next(this._contractTypes);
    }
    public get contractTypes(): Array<fromLookups.IContractType> {
        return this._contractTypes;
    }
    constructor(
        @Inject(LoggingService) private log: LoggingService,
        @Inject(UnsavedChangesService)
        private confirmservice: UnsavedChangesService
    ) {
        this.filterFormGroup = new UntypedFormGroup({
            jobListStatus: new UntypedFormControl(null),
            customers: new UntypedFormControl(null)
        });
        this.loadingData = true;
    }
    IsContractSelected = false;

    private _errors: Array<string>;
    private _selectedError: IShowErrors;

    private JobsSubject = new ReplaySubject<Array<IContractStructure>>(1);
    private _jobs: Array<IContractStructure>;

    private _jobliststatus: Array<IEntityFilter>;

    private _customers: Array<ICustomer>;

    private ContractTypesSubject = new ReplaySubject<
        Array<fromLookups.IContractType>
    >(1);
    private _contractTypes: Array<fromLookups.IContractType>;

    public filteredCustomers: Array<ICustomer> = [];
    public treeNodes: TreeNode<IContractStructure>[] = [];
    /**
     * Persist TreeTable expansion state across data refreshes.
     * PrimeNG TreeTable stores expansion on each TreeNode instance, so we keep a key set
     * and re-apply it when rebuilding `treeNodes`.
     */
    private expandedNodeKeys = new Set<string>();
    public filterFormGroup: UntypedFormGroup;
    public errorHelpText = '';
    public EntityFilterText = 'Customer/Job List Status';
    public CustomerFilterText = 'Customer Name';
    public active = true;
    public loadingData = true;
    public flattenedJobs: Array<IContractStructure> = [];
    public downloadOptions: Array<MenuItem> = [];
    public categories = [
        { value: 'Government', label: 'Government' },
        { value: 'Commercial', label: 'Commercial' },
        { value: 'Indirect', label: 'Indirect' }
    ];

    @Output() LoadJobListStatus = new ReplaySubject<any>(1);
    @Output() LoadCustomerJobs = new ReplaySubject<any>(1);

    allCustomersAllJobs: IEntityFilter;

    selectedContracts = [];

    @Input() public process: Process;
    @Output() selectStatus = new EventEmitter<IEntityFilter>();
    @Output() selectCustomer = new EventEmitter<Array<ICustomer>>();
    @Output() resetFilters = new EventEmitter<Array<ICustomer>>();
    @Output() rowUpdate = new EventEmitter<Array<IContractStructure>>();
    @Output() resetData = new EventEmitter();

    @Output() public ShowError = new EventEmitter<IShowErrors>();

    setupSubscriptions() {
        this.filterFormGroup.controls['jobListStatus'].valueChanges
            .pipe(
                // startWith({}),
                takeWhile(_ => this.active)
            )
            .subscribe(value => {
                this.loadingData = true;
                try {
                    // if (this.selectedContracts.length > 0) {
                    //     this.LoadCustomerJobs.next({
                    //         Customers: this.selectedContracts,
                    //         Status: value
                    //     });
                    // } else {
                    //     this.LoadCustomerJobs.next({
                    //         Customers: [],
                    //         Status: value
                    //     });
                    // }
                    // this.selectStatus.emit(value);
                    if (value.FilterID === 1 || value.FilterID === 2) {
                        this.filteredCustomers = this.customers.filter(
                            y => y.IsActive === true
                        );
                    } else {
                        this.filteredCustomers = this.customers;
                    }
                    // this.filterFormGroup.controls['customers'].reset();
                } catch (e) {
                    this.log.verbose(e);
                }
            });

        this.filterFormGroup.controls['customers'].valueChanges
            .pipe(
                // startWith({}),
                takeWhile(_ => this.active)
            )
            .subscribe(value => {
                this.loadingData = true;
                this.selectedContracts = [];
                if (value && value.length > 0) {
                    value.forEach(x => {
                        this.selectedContracts.push(x);
                    });
                    this.IsContractSelected = true;
                    this.LoadJobListStatus.next();
                } else {
                    this.IsContractSelected = false;
                    this.LoadJobListStatus.next();
                    this.filterFormGroup.controls['jobListStatus'].reset();
                }
                try {
                    this.selectCustomer.emit(value);
                } catch (e) {
                    this.log.verbose(e);
                }
            });
        combineLatest([this.JobsSubject, this.ContractTypesSubject])
            .pipe(takeWhile(() => this.active))
            .subscribe(([jobs, contracts]) => {
                if (jobs.length > 0) {
                    // Capture current UI expansion state before rebuilding nodes.
                    this.captureExpandedKeysFromNodes(this.treeNodes);
                    this.flattenedJobs = this.flattenNestedData(jobs);
                    this.treeNodes = this.mapJobsToTreeNodes(jobs);
                    this.loadingData = false;
                } else {
                    this.treeNodes = [];
                    this.loadingData = true;
                }
            });
    }

    transformDate(date): Date {
        return moment(date).startOf('day').toDate();
    }

    public updateRow(rowData: IContractStructure) {
        const rowDataForUpdate: IContractStructure = {
            QB_SubLevel: rowData.QB_SubLevel,
            QB_ListID: rowData.QB_ListID,
            QB_IsActive: rowData.QB_IsActive,
            QB_FullName: rowData.QB_FullName,
            QB_Name: rowData.QB_Name,
            QB_ParentListID: rowData.QB_ParentListID,
            QB_QBParentName: rowData.QB_QBParentName,
            IsCustomer: rowData.IsCustomer,
            IsContract: rowData.IsContract,
            IsChargeNumber: rowData.IsChargeNumber,
            IsInvoiceLevel: rowData.IsInvoiceLevel,
            ContractType: rowData.ContractType,
            IsFeeLevel: rowData.IsFeeLevel,
            CLIN: rowData.CLIN,
            FirstProcessDate: rowData.FirstProcessDate,
            LastActivity: rowData.LastActivity,
            ContractCategory: rowData.ContractCategory,
            StructureIsReadOnly: rowData.StructureIsReadOnly,
            CurrentAuthUser: rowData.CurrentAuthUser,
            CurrentTM: rowData.CurrentTM,
            Status: {
                StatusCode: null,
                Message: null,
                MsgProcessID: null,
                MsgEntityID: null
            },
            _children: []
        };

        this.rowUpdate.emit([rowDataForUpdate]);
    }

    public downloadTable(type) {
        const exportRows = this.flattenedJobs.map(row => ({
            Inactive: row.QB_IsActive === false ? 'X' : '',
            'Customer/Job Name': row.QB_Name,
            Contract: row.IsContract ? 'YES' : '',
            'Charge Number': row.IsChargeNumber ? 'YES' : '',
            'Contract Category': row.ContractCategory,
            'Contract Type': this.contractTypeLabel(row.ContractType),
            'Invoice Level': row.IsInvoiceLevel ? 'YES' : '',
            'Structure Locked': row.StructureIsReadOnly ? 'YES' : 'NO',
            'Authorized Users': row.CurrentAuthUser,
            'First Process Date': this.formatFirstProcessDate(row.FirstProcessDate)
        }));
        const worksheet = XLSX.utils.json_to_sheet(exportRows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Customer Job Structure');
        XLSX.writeFile(
            workbook,
            `${this.process.ProcessTitle}_${moment(new Date()).format(
                'MM-DD-YYYY'
            )}.${type}`
        );
    }

    ngOnDestroy() {
        this.active = false;
        this.resetData.emit();
    }
    ngOnInit() {
        this.downloadOptions = [
            {
                label: 'CSV',
                icon: 'pi pi-download',
                command: () => this.downloadTable('csv')
            },
            {
                label: 'Excel',
                icon: 'pi pi-download',
                command: () => this.downloadTable('xlsx')
            }
        ];
    }

    ngAfterViewInit() {
        this.setupSubscriptions();
    }

    refreshTable() {
        this.selectCustomer.emit([]);
    }

    customerFilter($event) {
        this.loadingData = true;
        this.selectedContracts = [];
        if ($event.value && $event.value.length > 0) {
            $event.value.forEach(x => {
                this.selectedContracts.push(x);
            });
            this.IsContractSelected = true;
            this.LoadJobListStatus.next();
        } else {
            this.IsContractSelected = false;
            this.LoadJobListStatus.next();
            this.filterFormGroup.controls['jobListStatus'].reset();
        }
        try {
            this.selectCustomer.emit($event.value);
        } catch (e) {
            this.log.verbose(e);
        }
    }

    public contractTypeOptions = () =>
        (this.contractTypes ?? []).map(x => ({
            label: x.ContractTypeName,
            value: x.ContractType
        }));

    public hasErrorStatus = ued =>
        ued && ued.Status && ued.Status.StatusCode >= DisplayMessageMinimum;

    public clearSelectedRows() {
        // no-op for TreeTable
    }

    public expandCollapse(action: string) {
        if (action === 'expand') {
            this.setExpandedState(this.treeNodes, true);
        } else {
            this.setExpandedState(this.treeNodes, false);
        }
        this.treeNodes = [...this.treeNodes];
    }

    public onTreeNodeExpand(event: any): void {
        const key = this.extractNodeKey(event?.node);
        if (key) this.expandedNodeKeys.add(key);
    }

    public onTreeNodeCollapse(event: any): void {
        const key = this.extractNodeKey(event?.node);
        if (key) this.expandedNodeKeys.delete(key);
    }

    public clearFilters() {
        this.filterFormGroup.controls['customers'].reset();
        this.filterFormGroup.controls['jobListStatus'].reset();
        this.resetFilters.emit([]);
    }

    public flattenNestedData(
        cs: Array<IContractStructure>
    ): Array<IContractStructure> {
        const flatten = ary => {
            return ary.reduce((r, { _children, ...rest }) => {
                r.push(rest);
                if (_children) {
                    r.push(...flatten(_children));
                }
                return r;
            }, []);
        };
        return flatten(cs);
    }

    public mapJobsToTreeNodes(
        jobs: Array<IContractStructure>
    ): TreeNode<IContractStructure>[] {
        return (jobs ?? []).map(job => ({
            key: job.QB_ListID,
            data: job,
            expanded: this.expandedNodeKeys.has(job.QB_ListID),
            children: this.mapJobsToTreeNodes(job._children ?? [])
        }));
    }

    public statusClass(row: IContractStructure): string {
        const code = row?.Status?.StatusCode;
        if (code === 1) return 'green';
        if (code === 2) return 'yellow';
        if (code && code >= 3 && code <= 6) return 'red';
        return '';
    }

    public onStatusClick(row: IContractStructure): void {
        const status = row?.Status;
        if (status && [2, 3, 4, 5].includes(status.StatusCode)) {
            this.ShowError.emit({ open: true, MsgEntityID: status.MsgEntityID });
        }
    }

    public canToggleContract(row: IContractStructure): boolean {
        if (!row?.QB_IsActive || row?.StructureIsReadOnly) return false;
        if (row?.QB_SubLevel !== 0 && row?.QB_SubLevel !== 1) return false;
        return Array.isArray(row._children) && row._children.length > 0;
    }

    public toggleContract(row: IContractStructure): void {
        if (!this.canToggleContract(row)) return;
        const doUpdate = () => {
            row.IsContract = !row.IsContract;
            row.Status = this.loadingStatus();
            this.updateRow(row);
        };
        if (Number(row.CurrentAuthUser) > 0) {
            this.confirmservice
                .confirmPromise({
                    headerText: 'Are you sure?',
                    dialogText: 'This will impact all current authorizations.',
                    okText: 'OK',
                    cancelText: 'Cancel'
                })
                .then(doUpdate)
                .catch(() => {});
            return;
        }
        doUpdate();
    }

    public canToggleInvoiceLevel(row: IContractStructure): boolean {
        if (!row?.QB_IsActive) return false;
        return !!(row.IsContract || row.IsChargeNumber);
    }

    public toggleInvoiceLevel(row: IContractStructure): void {
        if (!this.canToggleInvoiceLevel(row)) return;
        row.IsInvoiceLevel = !row.IsInvoiceLevel;
        row.Status = this.loadingStatus();
        this.updateRow(row);
    }

    public canEditContractCategory(row: IContractStructure): boolean {
        if (!row?.IsContract) return false;
        if (row.ContractCategory === 'Indirect' && row.FirstProcessDate) return false;
        return true;
    }

    public changeContractCategory(row: IContractStructure, value: string): void {
        const previous = row.ContractCategory;
        if (previous === value) return;
        const requiresConfirm =
            !!row.FirstProcessDate &&
            (previous === 'Indirect' || value === 'Indirect');
        const apply = () => {
            row.ContractCategory = value;
            row.Status = this.loadingStatus();
            this.updateRow(row);
        };
        if (!requiresConfirm) {
            apply();
            return;
        }
        this.confirmservice
            .confirmPromise({
                dialogText:
                    'Sessions (incl. Invoices) will be deleted. Changing a contract category invalidates previous calculations. Do you want to proceed?',
                okText: 'Yes',
                cancelText: 'No'
            })
            .then(apply)
            .catch(() => {
                row.ContractCategory = previous;
            });
    }

    public canEditContractType(row: IContractStructure): boolean {
        if (!row?.QB_IsActive) return false;
        if (!row?.IsChargeNumber && !row?.IsContract) return false;
        if (row.IsContract && row.FirstProcessDate) return false;
        const parent = this.flattenedJobs.find(x => x.QB_ListID === row.QB_ParentListID);
        return parent?.ContractCategory !== 'Indirect';
    }

    public contractTypeLabel(value: string): string {
        return (
            this.contractTypes?.find(x => x.ContractType === value)?.ContractTypeName ??
            value
        );
    }

    public changeContractType(row: IContractStructure, value: string): void {
        if (!value || row.ContractType === value) return;
        row.ContractType = value;
        row.Status = this.loadingStatus();
        this.updateRow(row);
    }

    public formatFirstProcessDate(value: string): string {
        return value ? moment(value).format('MM/DD/YYYY') : '';
    }

    public isSelectedErrorRow(row: IContractStructure): boolean {
        return this.selectedError?.MsgEntityID === row?.QB_ListID;
    }

    private expandAncestorsFor(listId: string): void {
        let current = this.flattenedJobs.find(x => x.QB_ListID === listId);
        while (current?.QB_ParentListID) {
            this.setNodeExpanded(this.treeNodes, current.QB_ParentListID, true);
            current = this.flattenedJobs.find(
                x => x.QB_ListID === current.QB_ParentListID
            );
        }
        this.treeNodes = [...this.treeNodes];
    }

    private loadingStatus() {
        return {
            StatusCode: ResponseStatus.Loading,
            Message: ''
        };
    }

    private setExpandedState(
        nodes: TreeNode<IContractStructure>[],
        expanded: boolean
    ): void {
        for (const node of nodes ?? []) {
            node.expanded = expanded;
            const key = this.extractNodeKey(node);
            if (key) {
                if (expanded) this.expandedNodeKeys.add(key);
                else this.expandedNodeKeys.delete(key);
            }
            if (node.children?.length) {
                this.setExpandedState(node.children, expanded);
            }
        }
    }

    private setNodeExpanded(
        nodes: TreeNode<IContractStructure>[],
        key: string,
        expanded: boolean
    ): boolean {
        for (const node of nodes ?? []) {
            if (node.key === key) {
                node.expanded = expanded;
                if (expanded) this.expandedNodeKeys.add(key);
                else this.expandedNodeKeys.delete(key);
                return true;
            }
            if (
                node.children?.length &&
                this.setNodeExpanded(node.children, key, expanded)
            ) {
                return true;
            }
        }
        return false;
    }

    private extractNodeKey(node: any): string | null {
        return (node?.key ?? node?.data?.QB_ListID ?? null) as string | null;
    }

    private captureExpandedKeysFromNodes(nodes: TreeNode<IContractStructure>[]): void {
        for (const node of nodes ?? []) {
            const key = this.extractNodeKey(node);
            if (key && node.expanded) {
                this.expandedNodeKeys.add(key);
            }
            if (node.children?.length) {
                this.captureExpandedKeysFromNodes(node.children);
            }
        }
    }
}
